import { render } from "./createOrganization.vue?vue&type=template&id=4c7d9084&scoped=true"
import script from "./createOrganization.vue?vue&type=script&lang=js"
export * from "./createOrganization.vue?vue&type=script&lang=js"

import "./createOrganization.vue?vue&type=style&index=0&id=4c7d9084&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c7d9084"]])

export default __exports__